var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courier-locations-map",style:({ height: _vm.height })},[(_vm.mapError)?_c('CAlert',{staticClass:"mb-2 py-2",attrs:{"color":"warning"}},[_vm._v(" "+_vm._s(_vm.mapError)+" ")]):_vm._e(),_c('div',{ref:"map",staticClass:"courier-locations-map-canvas"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }